<template>
    <div
        class="card"
        v-bind:class="externalAccept ? 'border-secondary' : 'border-primary'"
        v-bind:style="styleObject" />
</template>

<script>
    export default {
        props: {
            width: { type: Number, required: true },
            height: { type: Number, required: true },
            externalAccept: { type: Boolean, required: false, default: false }
        },
        computed: {
            styleObject() {
                const style = {
                    borderWidth: "3px",
                    height: `${this.height}px`,
                    width: `${this.width}px`
                };
                if (this.externalAccept) {
                    style.borderStyle = "solid";
                } else {
                    style.borderStyle = "dashed";
                    style.zIndex = "1";
                }
                return style;
            }
        }
    };
</script>
